import {MenuItem} from './menu.model';

export const FLEET_MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU.TEXT',
    isTitle: true
  },
  {
    id: 2,
    label: 'MENUITEMS.DASHBOARDS.TEXT',
    icon: 'fas fa-map-marked-alt',
    link: '/map-dashboard'
  },
  {
    id: 2,
    label: 'Insights',
    icon: 'ri-dashboard-line',
    link: '/'
  },
  {
    id: 3,
    label: 'Drivers',
    icon: 'driver-icon',
    link: '/customers'
  },
  {
    id: 6,
    label: 'Vehicles',
    icon: 'fas fa-car',
    link: '/vehicles'
  },
  {
    id: 4,
    label: 'Team',
    icon: 'fa fa-users',
    link: '/team'
  },
  {
    id: 5,
    label: 'FAQ',
    icon: 'fa fa-question-circle',
    link: '/faq'
  },
  {
    id: 6,
    label: 'Raise Complaint',
    icon: 'fa fa-comments',
    link: ''
  }
];
